// extracted by mini-css-extract-plugin
export default {"restaurantList":"index_restaurantList_y7K4d clearfix"};